<div fxFlexFill fxLayoutAlign="center center" fxLayout="column">
    <mat-icon *ngIf="messageType === 'info'" [svgIcon]="icon" class="icon"></mat-icon>
    <mat-spinner *ngIf="messageType === 'loading'" [diameter]="50" color="accent" ></mat-spinner>
    <h2>{{title}}</h2>
    <p>{{message}}</p>
    <button *ngIf="enableBtn" (click)="retry()" mat-button>{{btnMessage}}</button>
</div>